// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c126cfb0","404":"25b7e950","453":"8ab44547","805":"401bf7b9"}[chunkId] + ".chunk.js";
};